import __request__ from "routing/request";
export function set(JSONbody, requestOptions) {
  return __request__("POST", "/favorite_fields", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function add(JSONbody, requestOptions) {
  return __request__("PATCH", "/favorite_fields/add", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(JSONbody, requestOptions) {
  return __request__("PATCH", "/favorite_fields/remove", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
